import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { useHoardService } from "../../../services/hoardService"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()

    const { cancelFinancialHoard } = useHoardService()

    const { closeModal } = useUIActions()

    const submitCancelHoard = async (hoardId: string) => {
        Emitter.emit(Event.DB_SUBMIT)

        try {
            await cancelFinancialHoard(hoardId)

            Emitter.emit(Event.DB_SUBMIT_DONE, false, false, getRoutePath(RoutePath.HOARDS))
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo cancelar el acopio.')
        }
    }

    return {
        submitCancelHoard
    }
}
